// Pages/AdminRedirect.js
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { saveToken, isValidAdminToken } from "../utils/Authe";

const AdminRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      console.error("No token found in URL");
      navigate("/error");
      return;
    }

    // ✅ Validate JWT & user_type
    if (!isValidAdminToken(token)) {
      console.error("Token invalid, expired, or not an admin token");
      navigate("/error");
      return;
    }

    // ✅ Save valid admin token to sessionStorage
    saveToken(token);
    console.log("✅ Admin token verified and saved");

    // Redirect to dashboard
    navigate("/dashboard");
  }, [location, navigate]);

  return <div>Logging in... Please wait.</div>;
};

export default AdminRedirect;
